// Minimal browser polyfill for Node's `crypto` module, exposing only the
// functions escher-auth calls: createHash, createHmac, timingSafeEqual.
//
// Replaces `crypto-browserify` (the shim vite-plugin-node-polyfills would
// otherwise apply) to keep `elliptic` — which has an unpatched CVE
// (CVE-2025-14505) and is only reachable via crypto-browserify's ECDSA/ECDH
// paths (createSign / createVerify / createECDH), none of which are called
// at runtime — out of the dep graph. Aliased in vite.config.js.
//
// Kept as ESM: @rollup/plugin-commonjs by default only processes files under
// node_modules, so a CJS-authored file here would leak require/module.exports
// unresolved into the entry chunk, forcing Rollup to wrap the entire bundle
// in a CJS module helper (and emit a stray `export default …`).

import createHash from "create-hash";
import createHmac from "create-hmac";
import randomBytes from "randombytes";
import { Buffer } from "buffer";

// Constant-time buffer comparison. Mirrors Node's crypto.timingSafeEqual:
// throws if the two inputs have different byte lengths, otherwise returns
// true iff every byte matches.
function timingSafeEqual(a, b) {
  const bufA = Buffer.isBuffer(a) ? a : Buffer.from(a);
  const bufB = Buffer.isBuffer(b) ? b : Buffer.from(b);
  if (bufA.length !== bufB.length) {
    throw new RangeError("Input buffers must have the same byte length");
  }
  let diff = 0;
  for (let i = 0; i < bufA.length; i++) {
    diff |= bufA[i] ^ bufB[i];
  }
  return diff === 0;
}

export { createHash, createHmac, randomBytes, timingSafeEqual };
export default { createHash, createHmac, randomBytes, timingSafeEqual };
